const TOPICS = [
  { icon: 'ri-flight-takeoff-line', label: '动作大片', desc: '肾上腺素飙升的视觉盛宴', color: 'accent' },
  { icon: 'ri-emotion-happy-line', label: '喜剧之王', desc: '笑到停不下来的欢乐时光', color: 'primary' },
  { icon: 'ri-magic-line', label: '悬疑烧脑', desc: '反转不断的推理迷宫', color: 'secondary' },
  { icon: 'ri-planet-line', label: '科幻巨制', desc: '探索未来与未知世界', color: 'primary' },
  { icon: 'ri-sword-line', label: '武侠江湖', desc: '快意恩仇的东方传奇', color: 'accent' },
  { icon: 'ri-heart-line', label: '爱情经典', desc: '触动心弦的浪漫故事', color: 'secondary' },
  { icon: 'ri-ghost-line', label: '恐怖惊悚', desc: '胆量考验的极限体验', color: 'accent' },
  { icon: 'ri-emotion-line', label: '动画动漫', desc: '全年龄的奇幻冒险', color: 'primary' },
  { icon: 'ri-film-line', label: '纪录精选', desc: '真实世界的深度探索', color: 'secondary' },
];

export default function SectionIndex() {
  return (
    <section id="index" className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1200px] mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">
            专题索引
          </h2>
          <p className="mt-2 text-sm text-foreground-500">
            海量片库按类型精准导航，快速找到你想看的
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-3 md:gap-4">
          {TOPICS.map((topic) => (
            <a
              key={topic.label}
              href="#index"
              className="group flex flex-col items-center p-5 md:p-6 rounded-xl bg-background-200/60 hover:bg-background-200 border border-background-300/40 hover:border-background-300/70 transition-all cursor-pointer"
            >
              <div
                className={`w-12 h-12 flex items-center justify-center rounded-xl mb-3 ${
                  topic.color === 'accent'
                    ? 'bg-accent-500/15 text-accent-400'
                    : topic.color === 'secondary'
                    ? 'bg-secondary-500/15 text-secondary-400'
                    : 'bg-primary-500/15 text-primary-400'
                }`}
              >
                <i className={`${topic.icon} text-xl`}></i>
              </div>
              <span className="text-sm md:text-base font-semibold text-foreground-200 group-hover:text-foreground-100 transition-colors whitespace-nowrap">
                {topic.label}
              </span>
              <span className="text-xs text-foreground-600 mt-1 text-center">
                {topic.desc}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}